import { render } from "./ChallengeSpeculation.vue?vue&type=template&id=30887e67&scoped=true"
import script from "./ChallengeSpeculation.vue?vue&type=script&lang=js"
export * from "./ChallengeSpeculation.vue?vue&type=script&lang=js"

import "./ChallengeSpeculation.vue?vue&type=style&index=0&id=30887e67&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-30887e67"

export default script